import { AnyInterruptionRequiresUserInteraction, type InterruptionType, TaskState } from "@octopusdeploy/octopus-server-client";
import cn from "classnames";
import styles from "./style.module.less";
interface IconStyleProps {
    State: TaskState;
    IsCompleted: boolean;
    PendingInterruptionTypes: InterruptionType[];
    HasWarningsOrErrors: boolean;
    IsPrevious?: boolean;
    IsCurrent?: boolean;
}
export default (item: IconStyleProps, className?: string) => {
    let stateClass: string = item.State;
    if (item.PendingInterruptionTypes.length > 0 && !item.IsCompleted) {
        //if any of the interruptions require user interaction, we show the "Paused" state
        const anyRequiringUserInteraction = AnyInterruptionRequiresUserInteraction(item.PendingInterruptionTypes);
        if (anyRequiringUserInteraction) {
            stateClass = "Paused";
        }
        else {
            stateClass = TaskState.Executing;
        }
    }
    else if (item.State === TaskState.Success && item.HasWarningsOrErrors) {
        stateClass = "SuccessWithWarnings";
    }
    let iconStyles = cn(styles.status, styles[stateClass], className);
    if (item.IsPrevious) {
        iconStyles = cn(iconStyles, "status-previous");
    }
    else if (item.IsCurrent === false && item.IsPrevious === false) {
        iconStyles = cn(iconStyles, "status-archive");
    }
    return iconStyles;
};
export { IconStyleProps };
